module.exports = __webpack_public_path__ + "img/dianjiaoshou.865e894d.png";